ion-item-sliding {
  display: block;
  position: relative;
  width: 100%;
  overflow: hidden;
  user-select: none;
}

ion-item-sliding .item {
  user-select: none;
}

.item-sliding-active-slide .item {
  position: relative;
  transition: transform 500ms cubic-bezier(0.36, 0.66, 0.04, 1);
  opacity: 1;
  z-index: 2;
  pointer-events: none;
  will-change: transform;
}

.item-sliding-closing ion-item-options {
  pointer-events: none;
}

.item-sliding-active-swipe-end .item-options-end .item-option-expandable {
  /* stylelint-disable-next-line property-disallowed-list */
  padding-left: 100%;
  order: 1;
  transition-duration: 0.6s;
  transition-property: padding-left;
}
:host-context([dir=rtl]) .item-sliding-active-swipe-end .item-options-end .item-option-expandable {
  order: -1;
}

[dir=rtl] .item-sliding-active-swipe-end .item-options-end .item-option-expandable {
  order: -1;
}

@supports selector(:dir(rtl)) {
  .item-sliding-active-swipe-end .item-options-end .item-option-expandable:dir(rtl) {
    order: -1;
  }
}

.item-sliding-active-swipe-start .item-options-start .item-option-expandable {
  /* stylelint-disable-next-line property-disallowed-list */
  padding-right: 100%;
  order: -1;
  transition-duration: 0.6s;
  transition-property: padding-right;
}
:host-context([dir=rtl]) .item-sliding-active-swipe-start .item-options-start .item-option-expandable {
  order: 1;
}

[dir=rtl] .item-sliding-active-swipe-start .item-options-start .item-option-expandable {
  order: 1;
}

@supports selector(:dir(rtl)) {
  .item-sliding-active-swipe-start .item-options-start .item-option-expandable:dir(rtl) {
    order: 1;
  }
}